import { Autocomplete, TextField } from "@mui/material";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control } from "react-hook-form";

import { type RequirementMappingFormValues } from "../types";

interface QualificationsFieldProps {
  control: Control<RequirementMappingFormValues>;
  qualificationOptions: string[];
  isLoading: boolean;
}

export function QualificationsField(props: QualificationsFieldProps) {
  const { control, qualificationOptions, isLoading } = props;

  return (
    <FormFieldController
      required
      name="qualifications"
      control={control}
      label="Qualifications"
      sx={{ mb: 2 }}
      render={(field) => (
        <Autocomplete
          multiple
          options={qualificationOptions}
          loading={isLoading}
          value={field.value}
          // @ts-expect-error - field not typed correctly
          // FIXME: Automatically disabled during ESLint config update
          renderInput={(params) => <TextField {...params} error={Boolean(field.error)} />}
          onChange={(_, newValue) => {
            field.onChange(newValue);
          }}
          onBlur={field.onBlur}
        />
      )}
    />
  );
}
